export const SEARCH_REQUEST = 'citizens/SEARCH_REQUEST'
export const SEARCH_SUCCESS = 'citizens/SEARCH_SUCCESS'
export const SEARCH_FAILURE = 'citizens/SEARCH_FAILURE'

export const UNLINK_BY_PHONE_REQUEST = 'citizens/UNLINK_BY_PHONE_REQUEST'
export const UNLINK_BY_PHONE_SUCCESS = 'citizens/UNLINK_BY_PHONE_SUCCESS'
export const UNLINK_BY_PHONE_FAILURE = 'citizens/UNLINK_BY_PHONE_FAILURE'
